export default __webpack_public_path__ + "static/media/cm-img.4074cd2c.png";